import type { SVGProps } from 'react';

const SvgEloomiLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="15px"
    style={{
      shapeRendering: 'geometricPrecision',
      textRendering: 'geometricPrecision',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    }}
    width="15px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M -0.5,-0.5 C 2.16667,-0.5 4.83333,-0.5 7.5,-0.5C 7.5,2.16667 7.5,4.83333 7.5,7.5C 4.83333,7.5 2.16667,7.5 -0.5,7.5C -0.5,4.83333 -0.5,2.16667 -0.5,-0.5 Z"
        fill="#df524d"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 8.5,-0.5 C 10.8333,-0.5 13.1667,-0.5 15.5,-0.5C 15.5,0.166667 15.5,0.833333 15.5,1.5C 14.8333,2.83333 14.1667,4.16667 13.5,5.5C 13.5,4.16667 13.5,2.83333 13.5,1.5C 12.1667,1.5 10.8333,1.5 9.5,1.5C 9.5,2.83333 9.5,4.16667 9.5,5.5C 8.53862,3.73535 8.20528,1.73535 8.5,-0.5 Z"
        fill="#38af5d"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 1.5,1.5 C 2.68787,2.6843 3.85453,2.6843 5,1.5C 5.92481,4.1341 5.09148,5.30077 2.5,5C 1.66337,3.98873 1.33003,2.82207 1.5,1.5 Z"
        fill="#fceceb"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 7.5,-0.5 C 7.83333,-0.5 8.16667,-0.5 8.5,-0.5C 8.20528,1.73535 8.53862,3.73535 9.5,5.5C 10.8333,4.16667 12.1667,4.16667 13.5,5.5C 14.1667,4.16667 14.8333,2.83333 15.5,1.5C 15.5,3.5 15.5,5.5 15.5,7.5C 12.8333,7.5 10.1667,7.5 7.5,7.5C 7.5,4.83333 7.5,2.16667 7.5,-0.5 Z"
        fill="#44b062"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 13.5,5.5 C 12.1667,4.16667 10.8333,4.16667 9.5,5.5C 9.5,4.16667 9.5,2.83333 9.5,1.5C 10.8333,1.5 12.1667,1.5 13.5,1.5C 13.5,2.83333 13.5,4.16667 13.5,5.5 Z"
        fill="#d1ecd9"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M -0.5,7.5 C 2.16667,7.5 4.83333,7.5 7.5,7.5C 7.5,10.1667 7.5,12.8333 7.5,15.5C 7.16667,15.5 6.83333,15.5 6.5,15.5C 6.8468,12.6591 6.51347,10.6591 5.5,9.5C 3.93819,9.73286 2.60486,10.3995 1.5,11.5C 1.5,10.1667 0.833333,9.5 -0.5,9.5C -0.5,8.83333 -0.5,8.16667 -0.5,7.5 Z"
        fill="#4182c0"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 7.5,7.5 C 10.1667,7.5 12.8333,7.5 15.5,7.5C 15.5,7.83333 15.5,8.16667 15.5,8.5C 13.1667,8.5 10.8333,8.5 8.5,8.5C 8.5,10.8333 8.5,13.1667 8.5,15.5C 8.16667,15.5 7.83333,15.5 7.5,15.5C 7.5,12.8333 7.5,10.1667 7.5,7.5 Z"
        fill="#e7c937"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 15.5,8.5 C 15.5,10.1667 15.5,11.8333 15.5,13.5C 14.5084,13.6716 13.8417,13.3382 13.5,12.5C 12.1667,8.5 10.8333,8.5 9.5,12.5C 9.5,13.5 9.5,14.5 9.5,15.5C 9.16667,15.5 8.83333,15.5 8.5,15.5C 8.5,13.1667 8.5,10.8333 8.5,8.5C 10.8333,8.5 13.1667,8.5 15.5,8.5 Z"
        fill="#f7ce2c"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 13.5,12.5 C 12.1667,13.8333 10.8333,13.8333 9.5,12.5C 10.8333,8.5 12.1667,8.5 13.5,12.5 Z"
        fill="#fef9e7"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 6.5,15.5 C 4.16667,15.5 1.83333,15.5 -0.5,15.5C -0.5,13.5 -0.5,11.5 -0.5,9.5C 0.833333,9.5 1.5,10.1667 1.5,11.5C 1.36912,12.3764 1.70245,13.0431 2.5,13.5C 4.28818,12.7174 5.28818,11.3841 5.5,9.5C 6.51347,10.6591 6.8468,12.6591 6.5,15.5 Z"
        fill="#3980c3"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 5.5,9.5 C 5.28818,11.3841 4.28818,12.7174 2.5,13.5C 1.70245,13.0431 1.36912,12.3764 1.5,11.5C 2.60486,10.3995 3.93819,9.73286 5.5,9.5 Z"
        fill="#e6eff7"
        style={{
          opacity: 1,
        }}
      />
    </g>
    <g>
      <path
        d="M 9.5,12.5 C 10.8333,13.8333 12.1667,13.8333 13.5,12.5C 13.8417,13.3382 14.5084,13.6716 15.5,13.5C 15.5,14.1667 15.5,14.8333 15.5,15.5C 13.5,15.5 11.5,15.5 9.5,15.5C 9.5,14.5 9.5,13.5 9.5,12.5 Z"
        fill="#f5cf37"
        style={{
          opacity: 1,
        }}
      />
    </g>
  </svg>
);
export default SvgEloomiLogo;
